<div class="card login-scenario">
	<img class="card-img-top rounded-0"
		[src]="mainSlide.img">
	<form (ngSubmit)="doLogin()"
		#frmLogin="ngForm">
		<div class="card-body">
			<div class="row mb-3">
				<label for="colFormLabelSm"
					class="col-sm-3 col-form-label col-form-label-sm text-end">{{ 'LOGIN.EMAIL' | translate}}</label>
				<div class="col-sm-9">
					<input type="email"
						class="form-control form-control-sm"
						id="colFormLabelSm"
						name="username"
						#tbUsername="ngModel"
						[disabled]="working"
						[(ngModel)]="loginUserData.username"
						required
						placeholder="{{ 'LOGIN.EMAIL' | translate}}">
					<div class="text-danger"
						*ngIf="submitted && tbUsername.invalid">{{ 'LOGIN.UTENTE-OBBLIGATORIO'|translate }}</div>
				</div>
			</div>
			<div class="row mb-3">
				<label for="colFormLabelSm"
					class="col-sm-3 col-form-label col-form-label-sm text-end">{{ 'LOGIN.PASSWORD' | translate }}</label>
				<div class="col-sm-9">
					<div class="password-toggle">
						<input [type]="showPassword ? 'text' : 'password'"
							class="form-control form-control-sm"
							id="inputSigninPassword"
							name="password"
							[disabled]="working"
							#tbPassword="ngModel"
							[(ngModel)]="loginUserData.password"
							required
							placeholder="{{ 'LOGIN.PASSWORD' | translate }}">
						<button type="button"
							class="btn btn-link btn-sm password-toggle-btn"
							(click)="showPassword = !showPassword">
							<i class="fas"
								[ngClass]="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}"></i>
						</button>
					</div>
					<div class="text-danger"
						*ngIf="submitted && tbPassword.invalid">{{ 'LOGIN.PASSWORD-OBBLIGATORIA'|translate }}</div>
				</div>
			</div>
			<div class="row">
				<div class="col d-flex justify-content-end">
					<button type="submit"
						class="btn btn-b-n"
						name="button"
						[disabled]="working">{{ 'NAV-BAR.LOGIN' | translate }} <i class="fas fa-sign-in-alt"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="card-footer">
			<div class="control-group">
				<div class="row">
					<div class="col text-left">
						<a class="btn-link"
							(click)="doRegister()"
							data-dismiss="modal"
							aria-hidden="true"
							data-toggle="modal">{{ 'NAV-BAR.REGISTRAZIONE-ADV' | translate }}</a>
					</div>
					<div class="col border-start d-flex justify-content-end">
						<a class="btn-link"
							(click)="doRecover()"
							data-dismiss="modal"
							aria-hidden="true"
							data-toggle="modal">{{ 'NAV-BAR.RECUPERO-PASSWORD' | translate }}</a>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
